export default __webpack_public_path__ + "static/media/discovery-04.bc343fcc.png";